import { SignatureFormat } from '../signature-types';
import { decodeDataUrl } from './data-url';
export const isExternalImage = value => {
  const valueUrl = value.url;
  const {
    type
  } = decodeDataUrl(valueUrl) ?? {};
  const drawable = !valueUrl || type === SignatureFormat.POINTS;
  const writable = drawable || type === SignatureFormat.TEXT;
  return !drawable && !writable;
};
//# sourceMappingURL=drawer.js.map